import React, { Component } from "react";
import LazyLoad from "react-lazyload";
import ZrCard from "@ali/zr-renderer";
const IsVaildNumber = /^([0-9][0-9]*)+(.[0-9]{1,})?/g;

class Offer extends Component {
  render() {
    const { data, idx } = this.props;
    let cbu_ad_sessionid = '';
    let cbu_ad_adgroup_id = '';

    if (data.offerimgurl && data.offerimgurl.indexOf("cbu01.alicdn.com") > -1) {
      data.offerimgurl = `${data.offerimgurl.replace(
        /summ/g,
        "220x220"
      )}?_=2020`;
    }

    let priceStr = "";
    const match = data.offerprice.match(IsVaildNumber);
    priceStr = match ? match[0] : data.offerprice;
    //
    const isp4p = data.eurl.indexOf("dj.1688.com") != -1 ? 1 : 0;
    const mats = data.clickurl ? data.clickurl.match(/\d+/) : [];
    let offerid;
    if (mats && mats[0]) {
      offerid = mats[0];
    }

    const zrStyle = {
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    //添加打点参数
    let {trackInfo} = data;
    if(trackInfo && typeof trackInfo === 'string') {
      trackInfo = JSON.parse(trackInfo);
    } else if(!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;


    return (
      <div
        className="offer_exp"
        data-jplus-exp-url={`${data.impressionEurl}&idx=${idx}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
        style={zrStyle}
      >
        <ZrCard {...data} />
      </div>
    );
  }
}
export default Offer;
